import { Component, Input } from '@angular/core';

@Component({
    selector: 'mapp-mercer-mind-loader',
    templateUrl: './mercer-mind-loader.component.html',
    styleUrls: ['./mercer-mind-loader.component.scss'],
    standalone: false,
})
export class MercerMindLoaderComponent {
    @Input() text = 'Loading...';
}
